import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { withLoading } from '@ps/core-loading';
import {
  UserCompanyDto,
  UserCompanyListResponseDto,
} from './dtos/user-company.dto';
import {
  UserCompanyDetailMapper,
  UserCompanyMapper,
} from './mappers/user-company.mapper';
import {
  UserCompanyDetail,
  UserCompanySummary,
} from '../models/user-company.model';

/** Cross-domain endpoint: the user domain owns its own company reads. */
@Injectable({ providedIn: 'root' })
export class UserCompanyApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;
  private readonly _mapper = new UserCompanyMapper();
  private readonly _detailMapper = new UserCompanyDetailMapper();

  public companies(): Observable<UserCompanySummary[]> {
    return this._httpClient
      .get<UserCompanyListResponseDto>(`${this._baseUrl}/companies`, {
        context: withLoading('content'),
      })
      .pipe(map((response) => this._mapper.fromDtoList(response.companies)));
  }

  public companyDetail(companyId: number): Observable<UserCompanyDetail> {
    return this._httpClient
      .get<UserCompanyDto>(`${this._baseUrl}/companies/v2/${companyId}`, {
        context: withLoading('content'),
      })
      .pipe(map((dto) => this._detailMapper.fromDto(dto)));
  }
}
